import React from "react"
import { WorkshopShiftedTextButtonType } from "../../types/mainModulTypes"
import PrimaryButton from "../common/PrimaryButton"
import { useNavigate } from "react-router-dom"
import BaseSubheadline from "../common/BaseSubheadline"
import BaseRichtext from "../common/BaseRichtext"

export default function WorkshopShiftedTextButton(props: WorkshopShiftedTextButtonType) {
    const navigate = useNavigate()

    return (
        <div className="max-w-content mx-auto flex flex-col gap-8 sm:flex-row sm:gap-8 md:gap-16 px-4 lg:px-0">
            <div className="sm:w-[calc(50%-2rem)]">
                <BaseSubheadline label={props.workshopShiftedTextButtonLeftHeading} />
                <BaseRichtext content={props.workshopShiftedTextButtonLeftText} classProps="pb-8 pt-2" />
                <PrimaryButton
                    text={props?.workshopShiftedTextButtonLeftButtonText}
                    onClick={() => {
                        if (props.workshopShiftedTextButtonLeftButtonUrl.includes("https://")) {
                            window.open(props.workshopShiftedTextButtonLeftButtonUrl, "_blank")
                        } else {
                            navigate(props.workshopShiftedTextButtonLeftButtonUrl)
                        }
                    }}
                    active
                    classProps="w-full sm:w-fit"
                />
            </div>
            <div className="sm:pt-32 sm:w-[calc(50%-2rem)]">
                <BaseSubheadline label={props.workshopShiftedTextButtonRightHeading} />
                <BaseRichtext content={props.workshopShiftedTextButtonRightText} classProps="pb-8 pt-2" />
                <PrimaryButton
                    text={props?.workshopShiftedTextButtonRightButtonText}
                    onClick={() => {
                        if (props.workshopShiftedTextButtonRightButtonUrl.includes("https://")) {
                            window.open(props.workshopShiftedTextButtonRightButtonUrl, "_blank")
                        } else {
                            navigate(props.workshopShiftedTextButtonRightButtonUrl)
                        }
                    }}
                    active
                    classProps="w-full sm:w-fit"
                />
            </div>
        </div>
    )
}
